import {isDebug} from './Context';

function noop() {
}

export const debug = (...args) => isDebug ? console.debug(...args) : noop();
export const trace = (...args) => isDebug ? console.trace(...args) : noop();
export const warn = (...args) => isDebug ? console.warn(...args) : noop();
export const error = (...args) => console.error(...args);
